<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="header accent-700 p-24">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <div class="mt-8">Mémoria de Cálculo</div>
            <button mat-icon-button (click)="dimiss()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <div style="padding: 10px;">
        <table mat-table [dataSource]="dataSource"  class="memoryCalcStyle mat-elevation-z8 h-50" fusePerfectScrollbar>

            <!-- Procedure Name Column -->
            <ng-container matColumnDef="procedureName">
                <th mat-header-cell *matHeaderCellDef> Nome </th>
                <td mat-cell *matCellDef="let transaction" > {{transaction.procedureName}} </td>
            </ng-container>

            <!-- Procedure Code Column -->
            <ng-container matColumnDef="procedureCode">
                <th mat-header-cell *matHeaderCellDef> Cod. </th>
                <td mat-cell *matCellDef="let transaction"> {{transaction.procedureCode}} </td>
            </ng-container>

            <!-- Currency Procedure Column -->
            <ng-container matColumnDef="currencyProcedure">
                <th mat-header-cell *matHeaderCellDef> Indexador </th>
                <td mat-cell *matCellDef="let transaction"> {{transaction.currencyProcedure}} </td>
            </ng-container>

            <!-- Procedure Percentage Applied Column -->
            <ng-container matColumnDef="procedurePercentageApplied">
                <th mat-header-cell *matHeaderCellDef> % </th>
                <td mat-cell *matCellDef="let transaction"> {{transaction.procedurePercentageApplied || 0}}</td>
            </ng-container>

            <!-- Value Procedure Column -->
            <ng-container matColumnDef="valueProcedure">
                <th mat-header-cell *matHeaderCellDef> Valor </th>
                <td mat-cell *matCellDef="let transaction"> {{transaction.valueProcedure | currency:' '}} </td>
            </ng-container>

            <!-- Discount Procedure Column -->
            <ng-container matColumnDef="discountProcedure">
                <th mat-header-cell *matHeaderCellDef> Desconto </th>
                <td mat-cell *matCellDef="let transaction"> {{transaction.discountProcedure | currency:' '}} </td>
            </ng-container>

            <!-- Value Procedure Final Column -->
            <ng-container matColumnDef="valueProcedureFinal">
                <th mat-header-cell *matHeaderCellDef> Total </th>
                <td mat-cell *matCellDef="let transaction"> {{transaction.valueProcedureFinal | currency:' '}} </td>
            </ng-container>

            <!-- Currency Uco Column -->
            <ng-container matColumnDef="currencyUco">
                <th mat-header-cell *matHeaderCellDef> Indexador UCO </th>
                <td mat-cell *matCellDef="let transaction"> {{transaction.currencyUco || NA}} </td>
            </ng-container>

            <!-- Value Uco Column -->
            <ng-container matColumnDef="valueUco">
                <th mat-header-cell *matHeaderCellDef> Valor UCO </th>
                <td mat-cell *matCellDef="let transaction"> {{transaction.valueUco | currency:' '}} </td>
            </ng-container>

            <!-- UCO Percentage Applied Column -->
            <ng-container matColumnDef="ucoPercentageApplied">
                <th mat-header-cell *matHeaderCellDef> UCO % </th>
                <td mat-cell *matCellDef="let transaction"> {{transaction.ucoPercentageApplied || NA}} </td>
            </ng-container>

            <!-- Discount Uco Column -->
            <ng-container matColumnDef="discountUco">
                <th mat-header-cell *matHeaderCellDef> Desconto UCO </th>
                <td mat-cell *matCellDef="let transaction"> {{transaction.discountUco | currency:' '}} </td>
            </ng-container>

            <!-- Value Uco Final Column -->
            <ng-container matColumnDef="valueUcoFinal">
                <th mat-header-cell *matHeaderCellDef> Valor UCO Final </th>
                <td mat-cell *matCellDef="let transaction"> {{transaction.valueUcoFinal | currency:' '}} </td>
            </ng-container>

            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <!-- Data Row -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>